module.exports = __webpack_public_path__ + "static/img/gold-egg.8ea5694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/gold-egg.png
// module id = Wk0N
// module chunks = 215